if(typeof __WEBPACK_EXTERNAL_MODULE__474__ === 'undefined') { var e = new Error("Cannot find module 'assemblyscript'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__474__;